new Splide('.splide-rating-picker', {
    perPage: 3,
    perMove: 1,
    gap: 32,
    arrows: true,
    pagination: true,
    arrowPath: 'M0.589844 10.58L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.58Z',
    padding: {left: '0rem', right: '0rem'},

    breakpoints: {

        480: {
            perPage: 1,
            padding: {left: '1.5rem', right: '3rem'},
        },

        720: {
            perPage: 1,
            padding: {left: '1.5rem', right: '12rem'},
        },

        900: {
            perPage: 2,
            padding: {left: '2rem', right: '6rem'},
        },

        1163: {
            perPage: 2,
            gap: 24,
            padding: {left: '2rem', right: '12rem'},
        },
        1400: {
            arrows: false,
        },

    },
    classes: {
        arrows: 'splide__arrows px-6 w-full sm:px-8 md:px-0 top-[50%] -mt-4 absolute z-0 justify-between flex gap-4',
        arrow: 'splide__arrow items-center',
        prev: 'splide__arrow--prev relative bg-white',
        next: 'splide__arrow--next bg-white',
        // Add classes for pagination.
        pagination: 'splide__pagination px-6 sm:px-8 md:px-0 !block !-bottom-6 text-center mb-0', // container
        page: 'splide__pagination__page !w-2 !h-2 rounded-full', // each button
    },
}).mount();

// Get all elements with class readfull
const readFullButtons = document.querySelectorAll('.readfull');

// Iterate over each readfull button and add click event listener
readFullButtons.forEach(button => {
    button.addEventListener('click', function() {
        // Find the parent element of the clicked button
        const parentElement = this.parentElement;

        // Find the elements with classes shorttext and fulltext within the parent element
        const shortTextElement = parentElement.querySelector('.shorttext');
        const fullTextElement = parentElement.querySelector('.fulltext');

        // Toggle visibility of shorttext and fulltext elements
        if (shortTextElement.style.display !== 'none') {
            // If shorttext is visible, show fulltext and change button text to "Read Less"
            shortTextElement.style.display = 'none';
            fullTextElement.style.display = 'block';
            this.innerText = 'Läs mindre';
        } else {
            // If fulltext is visible, show shorttext and change button text to "Read More"
            shortTextElement.style.display = 'block';
            fullTextElement.style.display = 'none';
            this.innerText = 'Läs hela';
        }
    });
});

//# sourceMappingURL=splide-rating-picker.js.map
